export const invoices = {
  // Page
  pageTitle: "Invoices",

  // Filters
  invoiceStatus: "Status",
  invoiceDate: "Invoice Date",
  clearFilters: "Clear",

  // Table headers
  invoiceHeader: "Invoice",
  posCountHeader: "No. of POs",
  poInvoicesSidePanelTitle: "Number of POs",
  statusHeader: "Status",
  invoiceDateHeader: "Invoice Date",
  amountHeader: "Amount",
  penaltyHeader: "Penalty",
  totalDeductionHeader: "Deducted Amount",
  rejectReason: "Rejection Reason",
  penaltyApplied: "Penalty Applied",
  resendConfirmTitle: "Resend Invoice",
  resendConfirmMessage: "Are you sure you want to resend this invoice?",
  billingEntity: "Billing Entity",

  // Tooltips
  downloadInvoice: "Download Invoice",
  viewPos: "View POs",
  editInvoice: "Edit Invoice",

  // Messages
  loadingInvoices: "Loading invoices...",
  emptyInvoices: "You don't have any invoices yet",
  editSuccess: "Invoice updated successfully",
  editError: "Failed to update invoice",
};
